import React from 'react';

const WallabiesWarmCareBlanket = () => {
  return (
    <div className="container" style={{ padding: '40px 20px' }}>
      <div
        className="row"
        style={{
          backgroundColor: '#f8f9fa', // light background
          padding: '40px',
          borderRadius: '10px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="col-12">
          <h2
            style={{
              textAlign: 'center',
              color: '#007BFF', 
              marginBottom: '20px',
            }}
          >
            Wallabies Warm Care Blanket
          </h2>

          <p style={{ fontSize: '16px', lineHeight: '1.7', textAlign: 'justify' }}>
            The process of air convection is due to the transfer of heat. Through controlled diffusion, warm air moves from a high-volume blower to a low-pressure blanket.
          </p>

          <p style={{ fontSize: '16px', lineHeight: '1.7', textAlign: 'justify' }}>
            The warm air from the blower gets equally distributed in the warming blanket and, with the help of this blanket, the temperature of the patient's body can be capped to a certain level.
          </p>

          <p style={{ fontSize: '16px', lineHeight: '1.7', textAlign: 'justify' }}>
            The convective warmer draws ambient-temperature air through a HEPA air filter. The filtered air is warmed to a selected temperature and is then connected to a universal hose of the warmer. Blankets are suitable for all types of warmers.
          </p>

          <p style={{ fontSize: '16px', lineHeight: '1.7', textAlign: 'justify' }}>
            Micro perforation of white fabric with cubic honeycomb structure filters dust-free air to prevent surgical site infections. Wallabies warm care blankets are lint, latex-free, and fluid-resistant. The blanket is made from soft fabrics, ensuring even perforation for continuous, convective warming air throughout the patient's body.
          </p>

          <p style={{ fontSize: '16px', lineHeight: '1.7', textAlign: 'justify' }}>
            These blankets have been designed specifically for patients, offering a full range of warming blankets to accommodate every type of pediatric and adult patient and procedure.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WallabiesWarmCareBlanket;
